export default {
  'driver-out': 'Tài xế đã ra đi',
  'data-unavailable': 'Dữ liệu không có sẵn',
  delivered: 'Đã giao',
  'wrong-address': 'Địa chỉ sai',
  'not-present': 'Không có mặt',
  'order-canceled': 'Đơn hàng đã bị hủy',
  'delivery-attempted': 'Đã cố gắng giao hàng',
  rescheduled: 'Đã lên lịch lại',
  'date-unavailable': 'Ngày không có sẵn',
}
